<template>
  <section class="title-menu">
    <div class="title-holder">
      <h1
        v-html="globe.mainTitle"
        :style="{
          color: globe.mainTitleColor,
          fontSize: globe.mainTitleSize
        }"
      ></h1>
    </div>
    <div class="text-holder">
      <p
        v-html="globe.mainText"
        :style="{
          color: globe.mainTextColor,
          'font-size': globe.mainTextSize
        }"
      ></p>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {}
  },
  computed: {
    globe() {
      return this.rootStore.globe
    }
  }
}
</script>

<style lang="scss" scoped>
.title-menu {
  padding-top: 50px;

  h1 {
    font-size: 20px;
    font-weight: 300;
    line-height: 26px;
  }

  .text-holder {
    padding-top: 5px;
  }

  p {
    font-size: 15px;
    line-height: 24px;
  }
}
</style>
